import { XCircleIcon } from '@heroicons/react/20/solid'

export default function ErrorMessage({ message }) {
  return (
    <div className="mt-3 rounded-xl border border-red-500/30 bg-red-500/10 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-200">{message}</h3>
        </div>
      </div>
    </div>
  )
}
